<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="72"
    height="72"
    viewBox="0 0 72 72"
  >
    <g id="icon_lotto" transform="translate(-1 -0.5)">
      <circle
        id="타원_1"
        data-name="타원 1"
        cx="34"
        cy="34"
        r="34"
        transform="translate(3 2.5)"
        fill="none"
        stroke="#3e0ba5"
        stroke-miterlimit="10"
        stroke-width="4"
      />
      <circle
        id="타원_2"
        data-name="타원 2"
        cx="21.187"
        cy="21.187"
        r="21.187"
        transform="translate(15.5 15)"
        fill="#3e0ba5"
      />
      <path
        id="패스_93"
        data-name="패스 93"
        d="M98.382,78.72v1.512a3.433,3.433,0,0,1-.146,1.1,6.9,6.9,0,0,1-.292.7L90.209,98a2.379,2.379,0,0,1-.679.833,1.87,1.87,0,0,1-1.191.35H85.806l7.914-15.637a8.2,8.2,0,0,1,1.1-1.666H85.044a.812.812,0,0,1-.8-.8V78.72Z"
        transform="translate(-54.24 -51.22)"
        fill="#fff"
        stroke="#fff"
        stroke-width="1"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LottoFillIcon'
}
</script>

<style></style>
